<template>
    <header class="header" id="header">
        <div class="container header-content desktop">
            <router-link @click.native="pushHome" to="/"><img class="header-content__logo"
                                                              src="@/assets/icons/header-logo.png"
                                                              alt="Fibrillare Logo"
                                                              title="Fibrillare Logo"></router-link>
            <ul class="header-content__menu">
                <li>
                    <router-link class="header-content__menu__link" to="/empresa">Sobre Nós</router-link>
                </li>
                <li>
                    <router-link class="header-content__menu__link" :to="`/produtos/${firstProduct}`">Produtos
                    </router-link>
                </li>
                <li>
                    <router-link class="header-content__menu__link" :to="`/ambientes/${firstEnvironment}`">Ambientes
                    </router-link>
                </li>
                <li>
                    <a class="header-content__menu__link"
                       href="https://fibrillare.com.br/produtos/moveis-para-o-corporativo">
                        Corporativo
                    </a>
                </li>
                <li>
                    <router-link class="header-content__menu__link" :to="`/acabamentos/${firstFinish}`">Acabamentos
                    </router-link>
                </li>
                <li>
                    <router-link class="header-content__menu__link" :to="`/promocoes/${firstPromotion}`">
                        Promoções
                    </router-link>
                </li>
                <li>
                    <a class="header-content__menu__link" href="https://blog.fibrillare.com.br">Blog</a>
                </li>
                <li>
                    <router-link class="header-content__menu__link" to="/contato">Contato</router-link>
                </li>
            </ul>
            <ul class="header-content__socials">
                <li>
                    <a class="header-content__socials__link" href="https://www.facebook.com/FibrillareOficial"
                       target="_blank">
                        <img src="@/assets/icons/facebook.svg" alt="">
                    </a>
                </li>
                <li>
                    <a class="header-content__socials__link" href="https://www.instagram.com/fibrillare_moveis/"
                       target="_blank">
                        <img src="@/assets/icons/instagram.svg" alt="">
                    </a>
                </li>
                <li>
                    <a class="header-content__socials__link"
                       href="https://api.whatsapp.com/send?phone=5543999590178" target="_blank">
                        <img src="@/assets/icons/whats.svg" alt="">
                    </a>
                </li>
            </ul>
            <div class="search" :class="{active: toggleSearch}">
                <div class="relative">
                    <img class="first" src="@/assets/icons/search.svg" alt="">

                    <input :class="{active: toggleSearch}"
                           @keyup.enter="searchProduct"
                           placeholder="Pesquise um produto ou seu código de referência"
                           class="header-content__search__input"
                           v-model="search"
                           type="text">

                    <div @click="toggleSearch = !toggleSearch"
                         class="second">
                        <img src="@/assets/icons/close-white.svg" alt="">
                    </div>
                </div>
            </div>

            <div @click="toggleSearch = !toggleSearch" class="header-content__search">
                <img src="@/assets/icons/search.svg" alt="">
            </div>

            <div class="header-content__cart" @click="pushCart">
                <img src="@/assets/icons/cart.svg" alt="">
                <span class="total-itens">{{$root.number}}</span>
            </div>
        </div>
        <div class="header-mobile">
            <router-link to="/" @click="pushHome">
                <img class="mobile-logo" src="@/assets/icons/header-logo.png" alt="">
            </router-link>
            <button style="outline: none;" @click="toggleMenu = !toggleMenu" class="hamburger" type="button">
  <span class="hamburger-box">
    <span class="hamburger-inner"></span>
  </span>
            </button>
            <div class="header-mobile-content" :class="{active: toggleMenu}">
                <ul class="header-mobile-content__menu">
                    <li>
                        <div class="mobile-search">
                            <svg @click="toggleSearch = !toggleSearch" xmlns="http://www.w3.org/2000/svg" width="22"
                                 height="22" viewBox="0 0 22 22">
                                <path fill="#2b2b2b" fill-rule="evenodd"
                                      d="M21.665 20.117l-4.946-4.952c.601-.756 1.082-1.642 1.443-2.656a9.4 9.4 0 0 0 .54-3.173c0-1.29-.248-2.501-.746-3.636a9.163 9.163 0 0 0-1.997-2.966A9.776 9.776 0 0 0 12.984.722 9.194 9.194 0 0 0 9.35 0C8.063 0 6.852.24 5.72.722a9.776 9.776 0 0 0-2.975 2.012A9.163 9.163 0 0 0 .747 5.7 8.949 8.949 0 0 0 0 9.336C0 10.643.249 11.864.747 13a9.163 9.163 0 0 0 1.997 2.966 9.776 9.776 0 0 0 2.975 2.012 9.194 9.194 0 0 0 3.632.722c1.1 0 2.138-.18 3.117-.542.98-.361 1.88-.842 2.705-1.444l4.946 4.952c.12.12.254.206.4.258.146.051.27.077.373.077.103 0 .228-.026.374-.077.146-.052.279-.138.4-.258.222-.224.334-.482.334-.774 0-.292-.112-.55-.335-.774zM2.215 9.337c0-.98.18-1.91.541-2.786a7.502 7.502 0 0 1 1.533-2.27A6.804 6.804 0 0 1 6.57 2.76a6.824 6.824 0 0 1 2.782-.568c.996 0 1.924.19 2.782.568a6.804 6.804 0 0 1 2.28 1.521 7.502 7.502 0 0 1 1.533 2.27c.36.877.541 1.805.541 2.785 0 .998-.18 1.926-.54 2.786a7.118 7.118 0 0 1-1.547 2.295 7.193 7.193 0 0 1-2.267 1.535 6.96 6.96 0 0 1-2.782.554c-.996 0-1.923-.189-2.782-.567a7.246 7.246 0 0 1-2.28-1.535 7.256 7.256 0 0 1-1.533-2.282 7.127 7.127 0 0 1-.54-2.786z"/>
                            </svg>
                            <form @submit.prevent="searchProduct">
                                <input :class="{active: toggleSearch}"
                                    placeholder="Pesquise um produto ou seu código de referência"
                                    v-model="search"
                                    type="text">
                                    <button type="submit" class="searchSubmitBtn"></button>
                            </form>
                        </div>
                        <div @click="disableMenu" class="mobile-cart">
                            <div class="header-content__cart" @click="pushCart">
                                <img src="@/assets/icons/black-cart.svg" alt="">
                                <span class="total-itens">{{$root.number}}</span>
                            </div>
                        </div>
                    </li>
                    <li @click="disableMenu">
                        <router-link class="header-mobile-content__menu__link" to="/">Home</router-link>
                    </li>
                    <li @click="disableMenu">
                        <router-link class="header-mobile-content__menu__link" to="/empresa">Sobre Nós</router-link>
                    </li>
                    <li @click="disableMenu">
                        <router-link class="header-mobile-content__menu__link" :to="`/produtos/${firstProduct}`">
                            Produtos
                        </router-link>
                    </li>
                    <li @click="disableMenu">
                        <router-link class="header-mobile-content__menu__link" :to="`/ambientes/${firstEnvironment}`">
                            Ambientes
                        </router-link>
                    </li>
                    <li @click="disableMenu">
                        <a class="header-mobile-content__menu__link"
                           href="https://fibrillare.com.br/produtos/moveis-para-o-corporativo">
                            Corporativo
                        </a>
                    </li>
                    <li @click="disableMenu">
                        <router-link class="header-mobile-content__menu__link" :to="`/acabamentos/${firstFinish}`">
                            Acabamentos
                        </router-link>
                    </li>
                    <li @click="disableMenu">
                        <router-link class="header-mobile-content__menu__link" :to="`/promocoes/${firstPromotion}`">
                            Promoções
                        </router-link>
                    </li>
                    <li>
                        <a class="header-content__menu__link" href="https://blog.fibrillare.com.br">Blog</a>
                    </li>
                    <li @click="disableMenu">
                        <router-link class="header-mobile-content__menu__link" to="/contato">Contato</router-link>
                    </li>
                </ul>
                <ul class="header-mobile-content__socials">
                    <li>
                        <a class="header-mobile-content__socials__link"
                           href="https://www.facebook.com/FibrillareMoveis/" target="_blank">
                            <img src="@/assets/icons/face-black.svg" alt="">
                        </a>
                    </li>
                    <li>
                        <a class="header-mobile-content__socials__link" href="https://www.instagram.com/fibrillare/"
                           target="_blank">
                            <img src="@/assets/icons/insta-black.svg" alt="">
                        </a>
                    </li>
                    <li>
                        <a class="header-mobile-content__socials__link" href="#" target="_blank">
                            <img src="@/assets/icons/whats-black.svg" alt="">
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </header>
</template>

<script>
    export default {
        name: "Header",
        data() {
            return {
                toggleMenu: false,
                myBody: '',
                toggleSearch: false,
                search: '',
                firstEnvironment: 0,
                firstProduct: 0,
                firstFinish: 0,
                firstPromotion: 0,
            }
        },
        watch: {
            toggleMenu() {
                this.toggleMenu ? this.disableScroll() : this.enableScroll();
            }
        },
        methods: {
            disableMenu() {
                this.toggleMenu = false;
                window.scrollTo({
                    top: 0,
                    behavior: 'auto'
                })
            },
            pushHome() {
                this.toggleMenu = false;
            },
            pushCart() {
                this.toggleMenu = false;
                this.$router.push('/quotelist').catch(() => {
                })
            },
            disableScroll() {
                this.myBody.style.overflowY = 'hidden';
            },
            enableScroll() {
                this.myBody.style.overflowY = 'auto';
            },
            searchProduct() {
                this.toggleMenu = false;
                this.$router.push(`/search/${this.search}`).catch(() => {
                });
            },
            fetchCategories() {
                axios.get('/ambiente')
                    .then(r => {
                        this.firstEnvironment = r.data[0].friendly_url || r.data[0].id;
                    });

                axios.get('/categories?promocao=1')
                    .then(r => {
                        this.firstPromotion = r.data[0].url || r.data[0].id;
                    });

                axios.get('/categories')
                    .then(r => {
                        this.firstProduct = r.data[0].url || r.data[0].id;
                    });

                axios.get('/categoriaAcabamento')
                    .then(r => {
                        this.firstFinish = r.data[0].url || r.data[0].id;
                    });
            }
        },
        mounted() {
            this.myBody = document.querySelector('body');
            this.fetchCategories();
        },
    }
</script>

<style lang="scss" scoped>
    .header {
        width: 100%;
        background: #1d1d1d;
        position: fixed;
        top: 0;
        z-index: 15;
    }

    .header-mobile {
        display: none;
    }

    .mobile-search {
        position: absolute;
        left: 15px;
        top: 15px;
        display: flex;
        align-items: center;
        justify-content: center;

        input {
            width: 0;
            margin-left: 10px;
            border: none;
            border-bottom: 2px solid #2b2b2b;
            padding-bottom: 5px;
            transition: all .3s;
            outline: none;
            color: #2b2b2b;

            &.active {
                width: 215px;
            }
        }
    }

    .header-content {
        padding: 20px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;

        &__logo {
            cursor: pointer;
        }

        &__menu {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 5px;

            &__link {
                text-transform: uppercase;
                display: block;
                margin: 0 4px;
                padding: 10px 3px;
                color: #fff;
                font-size: 0.875rem;
                font-family: HelveticaNeueBold, Arial, sans-serif;

                &::after {
                    transition: all .3s;
                    width: 0;
                    height: 2px;
                    background: #fff;
                    content: '';
                    display: block;
                    position: relative;
                    top: 4px;
                }
            }
        }

        &__socials {
            display: flex;
            justify-content: space-between;
            border-left: 1px solid #fff;
            border-right: 1px solid #fff;
            padding: 0 8px;

            &__link {
                display: block;
                padding: 5px;
            }
        }

        &__cart {
            position: relative;
            cursor: pointer;
        }

        &__search {

            img {
                cursor: pointer;
            }

            &__input {
                top: 50%;
                transform: translate3d(0, -50%, 0);
                border: 1px solid #e5e5e5;
                position: absolute;
                right: -2px;
                border-radius: 8px;
                transition: all .4s;
                background: #1d1d1d;
                padding-left: 45px;
                font-size: 0.875rem;
                height: 42px;
                width: 0;
                color: #fff;
                font-family: 'HelveticaNeue', Arial, sans-serif;
                opacity: 0;
                z-index: 11;

                &.active {
                    width: 920px;
                    opacity: 1;
                }

                &:focus {
                    outline: none;
                }
            }
        }
    }

    .search.active .second {
        z-index: 11;
    }

    .first {
        position: absolute;
        left: 15px;
        top: -10px;
        z-index: 20;
        width: 20px;
    }

    .second {
        width: 20px;
        height: 20px;
        position: absolute;
        right: 3px;
        top: -7px;
        cursor: pointer;
    }

    .relative {
        position: relative;
    }

    .search {
        right: 0;
        top: 45px;
        border-radius: 8px;
        transition: all .4s;
        position: absolute;
        height: 42px;
        width: 0;
        font-size: 0.875rem;
        color: #fff;
        font-family: 'HelveticaNeue', Arial, sans-serif;
        opacity: 0;

        &.active {
            right: 35px;
            width: 920px;
            opacity: 1;
        }
    }

    .header-content__menu__link:hover.header-content__menu__link::after {
        width: 100%;
    }

    .total-itens {
        position: absolute;
        right: -8px;
        top: -8px;
        font-family: "Open Sans";
        font-size: 0.60rem;
        height: 17px;
        width: 17px;
        border-radius: 50%;
        background: #f2403f;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
    }

    .searchSubmitBtn{
        visibility: hidden;
    }

    @media only screen and(max-width: 1200px) {
        .header-content__menu__link {
            margin: 0 5px;
            font-size: 0.75rem;
        }

        .header-content {
            justify-content: space-around;
        }

        .header-content__logo {
            width: 140px;
        }
    }

    @media only screen and(max-width: 1023px) {
        .desktop {
            display: none;
        }
    }

    @media only screen and (min-width: 768px) and (max-width: 768px) {
        .header-mobile {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px 0 15px 15px;
            height: 79px;
            position: relative;
        }

        .mobile-logo {
            max-width: 130px;
        }

        .mobile-cart {
            position: absolute;
            right: 20px;
            top: 20px;
        }

        .header-mobile-content {
            position: absolute;
            top: 79px;
            left: 100%;
            width: 100%;
            height: calc(100vh - 79px);
            background: #fff;
            transition: all .3s;
            overflow: auto;

            &__menu {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                padding-top: 120px;
                font-size: 1.375rem;
                font-family: HelveticaNeue, Arial, sans-serif;

                &__link {
                    display: block;
                    font-size: 2rem;
                    color: #fff;
                    padding: 10px;
                    margin: 5px 0;
                    color: #2b2b2b;
                }
            }

            &__socials {
                margin-top: 80px;
                display: flex;
                align-items: center;
                justify-content: center;

                &__link {
                    display: block;
                    padding: 10px;

                    img {
                        width: 30px;
                        height: 30px;
                    }
                }
            }

            &.active {
                left: 0;
            }
        }
    }

    @media only screen and (max-width: 1023px) {
        .header-mobile {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px 0 15px 15px;
            height: 79px;
            position: relative;
        }

        .mobile-logo {
            max-width: 130px;
            margin-right: 20px;
        }

        .mobile-cart {
            position: absolute;
            right: 20px;
            top: 20px;
        }

        .header-mobile-content {
            position: absolute;
            top: 79px;
            left: 100%;
            width: 100%;
            height: calc(100vh - 79px);
            background: #fff;
            transition: all .3s;
            overflow: auto;

            &__menu {
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                padding-top: 40px;
                font-family: HelveticaNeue, Arial, sans-serif;

                &__link {
                    display: block;
                    color: #fff;
                    padding: 10px;
                    margin: 5px 0;
                    color: #2b2b2b;
                    font-size: 1.275rem;
                }
            }

            &__socials {
                margin-top: 30px;
                display: flex;
                align-items: center;
                justify-content: center;

                &__link {
                    display: block;
                    padding: 10px;
                }
            }

            &.active {
                left: 0;
            }
        }
    }

    @media only screen and (max-width: 767px) {
        .header-mobile-content__menu__link {
            display: block;
            padding: 7px;
            margin: 5px 0;
            color: #2b2b2b;
            font-size: 1.275rem;
        }

        .header-mobile-content__socials {
            margin-top: 10px;
        }
    }
</style>